
const HOST = {
  dev: {
    // 项目接口前缀
    baseUrl: '/crmApis',
    // 妥妥递appId和接口链接
    ttdUrl: 'https://test.totodi.com.cn:37893',
    // 跳转妥妥递小程序版本
    ttdVersion: 'trial',
    // wps跳转链接
    wpsUrl: 'https://wpstest-docker.gyasset.com/wps-ui/#/Home?data=',
    // 埋点的code和链接
    webTracingUrl: 'https://eas-test.gyasset.com/event/insertEvents',
    webTracingAppCode: 'crm-weixin-dev',
  },
  test: {
    // 项目接口前缀
    baseUrl: '/admin',
    // 妥妥递appId和接口链接
    ttdUrl: 'https://test.totodi.com.cn:37893',
    // 跳转妥妥递小程序版本
    ttdVersion: 'trial',
    // wps跳转链接
    wpsUrl: 'https://wpstest-docker.gyasset.com/wps-ui/#/Home?data=',
    // 埋点的code和链接
    webTracingUrl: 'https://eas-test.gyasset.com/event/insertEvents',
    webTracingAppCode: 'crm-weixin-dev',
  },
  qa: {
    // 项目接口前缀
    baseUrl: 'https://qa.gyasset.com/admin',
    // 妥妥递appId和接口链接
    ttdUrl: 'https://test.totodi.com.cn:37893',
    // 跳转妥妥递小程序版本
    ttdVersion: 'trial',
    // wps跳转链接
    wpsUrl: 'https://wpstest-docker.gyasset.com/wps-ui/#/Home?data=',
    // 埋点的code和链接
    webTracingUrl: 'https://eas-test.gyasset.com/event/insertEvents',
    webTracingAppCode: 'crm-weixin-uat',
  },
  dr: {
    // 项目接口前缀
    baseUrl: 'https://dr-ds.gyasset.com/admin',
    // 妥妥递appId和接口链接
    ttdUrl: 'https://sghf.totodi.com',
    // 跳转妥妥递小程序版本
    ttdVersion: 'release',
    // wps跳转链接
    wpsUrl: 'https://wps-docker.gyasset.com/wps-ui/#/Home?data=',
    // 埋点的code和链接
    webTracingUrl: 'https://eas.gyasset.com/event/insertEvents',
    webTracingAppCode: 'crm-weixin-prod',
  },
  prod: {
    // 项目接口前缀
    baseUrl: 'https://ds.gyasset.com/admin',
    // 妥妥递appId和接口链接
    ttdUrl: 'https://sghf.totodi.com',
    // 跳转妥妥递小程序版本
    ttdVersion: 'release',
    // wps跳转链接
    wpsUrl: 'https://wps-docker.gyasset.com/wps-ui/#/Home?data=',
    // 埋点的code和链接
    webTracingUrl: 'https://eas.gyasset.com/event/insertEvents',
    webTracingAppCode: 'crm-weixin-prod',
  }
}

export const env = HOST[process.env.VUE_APP_SERVER_ENV];